import { Component, OnInit } from '@angular/core';
import { CoreService } from '../../services/coreService';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-payment-success',
    templateUrl: './payment-success.component.html',
    styleUrls: ['./payment-success.component.scss'],
    standalone: true,
    imports: []
})
export class PaymentSuccessComponent implements OnInit {

  private sub: any;
  encryptedId: string;

  constructor(private route: ActivatedRoute, private router: Router) {


  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.encryptedId = params["id"];
    });

    // Redirect to another route after 5 seconds
    setTimeout(() => {
      this.router.navigate(['valet-guest/' + this.encryptedId]);  // Replace '/other-route' with your actual route
    }, 3500);
  }

}
